import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const ProductInfo = styled.p`
  max-width: 500px;
  margin: ${layout.measurements.spacing075} 0;
  color: ${p => p.theme.text.secondary};
  a {
    color: ${p => p.theme.text.secondary};
    text-decoration: underline;
  }
`;
